(function () {
  var MOBILE = '.mobile-facets__details.js-filter';
  var DESKTOP = '#FacetFiltersForm .facets__disclosure.js-filter';
  var MAIN = '.mobile-facets__disclosure';

  function mobileMain(root) {
    return (root || document).querySelector(MAIN);
  }

  function mobileMainList(details) {
    return details && details.closest('.mobile-facets__main');
  }

  function openMobileSubmenu(details) {
    var main = mobileMainList(details);
    details.classList.add('menu-opening');
    if (main) main.classList.add('submenu-open');

    document.querySelectorAll(MOBILE + '[open]').forEach(function (other) {
      if (other === details) return;
      other.removeAttribute('open');
      other.classList.remove('menu-opening');
    });
  }

  function closeMobileSubmenu(details) {
    details.classList.remove('menu-opening');
    var main = mobileMainList(details);
    if (main && !main.querySelector(MOBILE + '[open]')) {
      main.classList.remove('submenu-open');
    }
  }

  function onMobileToggle(event) {
    var details = event.currentTarget;
    if (details.open) openMobileSubmenu(details);
    else closeMobileSubmenu(details);
  }

  function bindMobileSubmenus(root) {
    (root || document).querySelectorAll(MOBILE).forEach(function (details) {
      details.removeEventListener('toggle', onMobileToggle);
      details.addEventListener('toggle', onMobileToggle);

      if (details.open) openMobileSubmenu(details);
    });
  }

  function setFilterHeaderOffset() {
    var group = document.querySelector('.shopify-section-group-header-group');
    var header = document.querySelector('.section-header');
    var el = group || header;
    if (!el) return;
    var bottom = Math.max(0, Math.round(el.getBoundingClientRect().bottom));
    document.documentElement.style.setProperty('--header-bottom-position', bottom + 'px');
    document.documentElement.style.setProperty('--viewport-height', window.innerHeight + 'px');
  }

  function onFilterResize() {
    if (!document.body.classList.contains('uc-filter-open')) return;
    setFilterHeaderOffset();
  }

  function openFilterChrome() {
    var group = document.querySelector('.shopify-section-group-header-group');
    var header = document.querySelector('.section-header');
    var el = group || header;
    // Bring announcement + logo header back into view (same chrome as the menu)
    if (el && el.getBoundingClientRect().top < 0) {
      window.scrollTo(0, 0);
    }
    setFilterHeaderOffset();
    document.body.classList.add('uc-filter-open');
    if (header) header.classList.add('uc-filter-open');
    if (group) group.classList.add('uc-filter-open');
    window.addEventListener('resize', onFilterResize);
    // Recalc after scroll/layout settles
    requestAnimationFrame(setFilterHeaderOffset);
    setTimeout(setFilterHeaderOffset, 50);
  }

  function closeFilterChrome() {
    document.body.classList.remove('uc-filter-open');
    var header = document.querySelector('.section-header');
    var group = document.querySelector('.shopify-section-group-header-group');
    if (header) header.classList.remove('uc-filter-open');
    if (group) group.classList.remove('uc-filter-open');
    window.removeEventListener('resize', onFilterResize);
  }

  function closeMobileFilterDrawer(event) {
    var details = mobileMain();
    if (!details || !details.open) {
      closeFilterChrome();
      return;
    }
    var drawer = details.closest('menu-drawer');
    var summary = details.querySelector('summary');
    if (drawer && typeof drawer.closeMenuDrawer === 'function' && event) {
      drawer.closeMenuDrawer(event, summary);
      if (summary) summary.setAttribute('aria-expanded', 'false');
    } else {
      details.classList.remove('menu-opening');
      details.removeAttribute('open');
      document.body.classList.remove('overflow-hidden-mobile');
      if (summary) summary.setAttribute('aria-expanded', 'false');
    }
    closeFilterChrome();
  }

  function bindMobileDrawer(root) {
    var main = mobileMain(root);
    if (!main) return;

    if (main.dataset.ucFacetMainBound !== 'true') {
      main.dataset.ucFacetMainBound = 'true';
      main.addEventListener('toggle', function () {
        if (main.open) {
          main.classList.add('menu-opening');
          openFilterChrome();
        } else {
          main.classList.remove('menu-opening');
          main.querySelectorAll(MOBILE).forEach(function (details) {
            details.removeAttribute('open');
            details.classList.remove('menu-opening');
          });
          var list = main.querySelector('.mobile-facets__main');
          if (list) list.classList.remove('submenu-open');
          closeFilterChrome();
        }
      });
    }

    if (main.open) openFilterChrome();
  }

  function onDesktopToggle(event) {
    var details = event.currentTarget;
    if (!details.open) return;
    document.querySelectorAll(DESKTOP + '[open]').forEach(function (other) {
      if (other !== details) other.removeAttribute('open');
    });
  }

  function bindDesktopDisclosures(root) {
    (root || document).querySelectorAll(DESKTOP).forEach(function (details) {
      details.removeEventListener('toggle', onDesktopToggle);
      details.addEventListener('toggle', onDesktopToggle);
    });
  }

  function bindHeaderMenuClosesFilter() {
    if (document.documentElement.dataset.ucFilterMenuBound === 'true') return;
    document.documentElement.dataset.ucFilterMenuBound = 'true';

    document.addEventListener(
      'click',
      function (event) {
        if (!document.body.classList.contains('uc-filter-open')) return;
        var menuSummary = event.target.closest('header-drawer summary.header__icon--menu');
        if (!menuSummary) return;
        event.preventDefault();
        event.stopPropagation();
        if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
        closeMobileFilterDrawer(event);
      },
      true
    );
  }

  function bindHeaderClose(root) {
    (root || document).querySelectorAll('.mobile-facets__header-close').forEach(function (btn) {
      if (btn.dataset.ucFacetCloseBound === 'true') return;
      btn.dataset.ucFacetCloseBound = 'true';
      btn.addEventListener(
        'click',
        function (event) {
          event.preventDefault();
          event.stopPropagation();
          if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
          closeMobileFilterDrawer(event);
        },
        true
      );
    });
  }

  function init(root) {
    bindMobileDrawer(root);
    bindMobileSubmenus(root);
    bindDesktopDisclosures(root);
    bindHeaderClose(root);
    bindHeaderMenuClosesFilter();
  }

  window.ucInitFacetDisclosures = init;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
